var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenMessage = function SvgGreenMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#0D874A",
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#green-message_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M18.332 10c-.53-2.657-2.991-4.667-5.947-4.667-3.343 0-6.053 2.57-6.053 5.74 0 1.523.625 2.907 1.646 3.934.224.226.374.535.314.853-.1.52-.326 1.005-.658 1.409.872.16 1.779.016 2.557-.394.275-.145.412-.218.51-.232.067-.01.155 0 .298.023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.332 14.84c0 1.938 1.642 3.509 3.667 3.509q.358 0 .709-.066c.168-.032.253-.048.311-.039.059.01.142.054.309.142.471.25 1.02.34 1.549.241a1.94 1.94 0 0 1-.399-.86c-.037-.195.054-.384.19-.522a3.41 3.41 0 0 0 .997-2.404c0-1.937-1.642-3.508-3.666-3.508s-3.667 1.57-3.667 3.508Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "green-message_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 4h16v16H5z"
  })))));
};
export default SvgGreenMessage;